
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 182 255","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M124.222 97.614L175.682 71.884C180.742 69.355 182.69 63.137 180.003 58.176L151.403 5.38603C148.833 0.644028 142.963 -1.20897 138.138 1.20503L88.439 26.055C33.888 53.32 0 108.159 0 169.17V245C0 250.523 4.477 255 10 255H70C75.523 255 80 250.523 80 245V169.17C80 138.667 96.944 111.248 124.222 97.614ZM60 169.17V235H20V169.17C20 115.784 49.65 67.801 97.382 43.944L138.428 23.422L157.495 58.617L115.279 79.725C81.182 96.768 60 131.041 60 169.17Z"}})])
          )
        }
      }
    